import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

export const loadPersons = createAction(
  '[Person/API] Load Persons',
  props<{ persons: any[] }>()
);

export const addPerson = createAction(
  '[Person/API] Add Person',
  props<{ person: any }>()
);

export const upsertPerson = createAction(
  '[Person/API] Upsert Person',
  props<{ person: any }>()
);

export const addPersons = createAction(
  '[Person/API] Add Persons',
  props<{ persons: any[] }>()
);

export const upsertPersons = createAction(
  '[Person/API] Upsert Persons',
  props<{ persons: any[] }>()
);

export const updatePerson = createAction(
  '[Person/API] Update Person',
  props<{ person: Update<any> }>()
);

export const updatePersons = createAction(
  '[Person/API] Update Persons',
  props<{ persons: Update<any>[] }>()
);

export const deletePerson = createAction(
  '[Person/API] Delete Person',
  props<{ id: string }>()
);

export const deletePersons = createAction(
  '[Person/API] Delete Persons',
  props<{ ids: string[] }>()
);

export const clearPersons = createAction('[Person/API] Clear Persons');
